module.exports = __webpack_public_path__ + "img/full7-min.221bc654.png";